import {
  GenericTable,
  GenericTableVariant,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { modalTypes } from "constants/types";
import { defaultColumns } from "layout/watchwords/WatchwordsTable/columns";
import { isNil } from "lodash";
import { func } from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { fetchWatchwordsList } from "slices/watchwords/list/actions";
import { selectWatchwordsList } from "slices/watchwords/list/selectors";

import classes from "./ScoringSwapWatchwordsListModal.module.scss";

const ScoringSwapWatchwordsListModal = ({ onConfirm }) => {
  const dispatch = useDispatch();
  const watchwordsLists = useSelector(selectWatchwordsList);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const isSubmitDisabled = isNil(selectedIndex) || selectedIndex <= -1;

  useEffect(() => {
    dispatch(fetchWatchwordsList());
  }, []);

  const onClickConfirm = () => {
    dispatch(hideModal(modalTypes.SCORING_SWAP_WATCHWORDS_LIST));
    onConfirm(watchwordsLists[selectedIndex]);
  };

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.SCORING_SWAP_WATCHWORDS_LIST));
  };

  const onRowClick = (_, __, index) => {
    setSelectedIndex(index);
  };

  return (
    <Modal
      data-testid="swap-watchwords-list-modal"
      className={clsx("fade-in", classes.swapWatchwordsList)}
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Change Watchwords List</Modal.Header>

      <Modal.Body>
        <GenericTable
          columns={defaultColumns}
          data={watchwordsLists}
          defaultSortColumnIndex={-1}
          onRowClick={onRowClick}
          selectedIndex={selectedIndex}
          variant={GenericTableVariant.bordered}
        />
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="save-button"
          disabled={isSubmitDisabled}
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Confirm Change
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

ScoringSwapWatchwordsListModal.propTypes = {
  onConfirm: func.isRequired,
};

export default ScoringSwapWatchwordsListModal;
